import { toast } from 'react-toastify';
import { addWishlistFun, delWishFun, userWishlistIdFun } from '../api/userAPI';

export const handleWishlistClick = async (id, userWishlist, type, setUserWishlist) => {
    try {
        const isFavorite = userWishlist?.includes(id);
        console.log(type, 'type');
        const name =
            {
                trip: 'Trip',
                act: 'Activity',
                gu: 'Guide',
                camp: 'Camp',
                ayur: 'Ayurveda'
            }[type] || 'Unknown';

        if (isFavorite) {
            await delWishFun(type, id);
            toast.warn(`${name} removed from Wishlist`);
        } else {
            await addWishlistFun(type, { packageId: id });
            toast.success(`${name} added to Wishlist`);
        }

        const res = await userWishlistIdFun(type);
        // no saved items left → the list can come back empty
        if (res.status === 200) setUserWishlist(res.data?.[0]?.[type] || []);
    } catch (error) {
        console.log(error);
    }
};
